/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { EnvironmentSpecificService } from './environment-specific.service';
import { SocketIoModule } from 'ngx-socket-io';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { SafePipeModule } from 'safe-pipe';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

@Injectable()
export class AppSocket extends Socket {
  
  constructor(
    private _envService: EnvironmentSpecificService,) {
    super({ url: _envService.envSpecific.appUrl, 
    options: {
      path:_envService.envSpecific.wsPath,
      transports: ['websocket'],  // https://stackoverflow.com/a/52180905/8987128
      upgrade: false,
      query:  { token : JSON.parse(localStorage.getItem("currentUser")).socketToken },
      reconnection: true
    } });
  }

  //"_envService.envSpecific.apiUrl.replace("/api","copssocket")"
  
}

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbTimepickerModule
} from '@nebular/theme';
import { SharedModule } from './pages/shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
import { Http } from './pages/shared/http-client/http-client.component';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    SharedModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      closeButton: true,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      enableHtml: true,
      maxOpened: 3
    }),
    SocketIoModule,
    SafePipeModule,
    PickerModule,
    NbTimepickerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDyIqn2j3JTEloO8XB3resXPVLhbuudA1c',
      libraries: ['places']
    }),
  ],
  bootstrap: [AppComponent],
  providers:[
    EnvironmentSpecificService,
    Http,
    AppSocket
  ]
})
export class AppModule {
}
